import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React, { Component } from 'react';

var CodeLine =
/*#__PURE__*/
function (_Component) {
  _inherits(CodeLine, _Component);

  function CodeLine() {
    _classCallCheck(this, CodeLine);

    return _possibleConstructorReturn(this, _getPrototypeOf(CodeLine).apply(this, arguments));
  }

  _createClass(CodeLine, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          attributes = _this$props.attributes,
          children = _this$props.children;
      return React.createElement("div", Object.assign({
        className: "note-editor-code-line"
      }, attributes), children);
    }
  }]);

  return CodeLine;
}(Component);

export default CodeLine;